import { Stream } from "src/models";
import { _ } from ".";

export namespace SeoService {

    const defaultKeyword = () => _("seoDefaultKeyword");
    const defaultDescription = () => _("seoDefaultDescription");

    const getKeyword = (title: string) => _("seoKeyworkd").replaceAll("{title}", title);
    const getDescription = (title: string) => _("seoDescription").replaceAll("{title}", title);

    export const setMediaMetadata = (poster?: string, currentStream?: Stream) => {
        if ('mediaSession' in navigator) {

            //@ts-ignore
            navigator.mediaSession.metadata = new MediaMetadata({
                //@ts-ignore
                ...navigator.mediaSession.metadata,
                artist: currentStream?.name || currentStream?.familyName ? currentStream?.name + " " + currentStream?.familyName : _("websiteTitle"),
                //@ts-ignore
                artwork: poster ? [{ src: poster, sizes: '760x428', type: 'image/png' }] : navigator.mediaSession.metadata.artwork
            });
        }
    };

    export const setHeaderMetadata = (title?: string, image?: string) => {

        document.title = `${title}${title ? " - " : ""}${_("websiteTitle")}`;

        setHtmlMeta("og:url", window.location.href, "property");
        setHtmlMeta("twitter:url", window.location.href);

        setHtmlMeta('og:title', document.title, 'property');
        setHtmlMeta('twitter:title', document.title, 'property');

        if (image) {
            setHtmlMeta("og:image", image, "property");
        }

        setHtmlMeta("keywords", title ? getKeyword(title || "") : defaultKeyword());

        const description = title ? getDescription(title) : defaultDescription();
        setHtmlMeta("description", description);
        setHtmlMeta("og:description", description, "property");
        setHtmlMeta("twitter:description", description);


    };

    const setHtmlMeta = (key: string, value?: string, propertyKey = 'name') => {
        const meta = document.querySelector(`[${propertyKey}="${key}"]`);
        // set default keywords
        if (key === 'keywords' && !value) {
            value = defaultKeyword();
        } else if (key === 'description' && !value) {
            value = defaultDescription();
        }
        meta && meta.setAttribute("content", value || "");
    };

}
